/* Rose & Born · Depict search (theme side).
   1. Header: the theme's magnifier (snippets/rb-search-trigger.liquid) clicks Depict's hidden button.
   2. Before typing, on desktop, the search window gets the v2 layout (canvas "Search" page):
      left  – Try asking (mirrors Depict's suggested queries), Categories, Services
      middle – Depict's top picks ("The Essentials"), three across
      right – Recently viewed (from rb_recently_viewed, see snippets/rb-recently-viewed.liquid)
   3. Every product card in the window gets a link to its product page. The cloth line under the name was
      removed 5 Oct (Carl: it repeats the product name); putCloth() is kept but does nothing.
   4. Prices in the site's format per market ("2,000 SEK", "€1.700"), as snippets/rb-money.liquid writes them.
   Depict renders and runs the window itself (search, AI answer, filters); this only adds next to its markup and
   re-applies when Depict re-renders. Depict's own nodes are never rewritten, only given classes/attributes. */
(function () {
  var MODAL = '.depict-gpt-search-modal';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DESKTOP = window.matchMedia('(min-width: 980px)'); // Depict's own desktop/mobile switch

  /* ---------- 1 · header icon ---------- */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rb-search-open]');
    if (!trigger) return;
    var depictButton = document.querySelector('.rb-depict-search-host .opens-depict, depict-search-button .opens-depict');
    if (!depictButton) return;
    event.preventDefault();
    depictButton.click();
  });

  /* ---------- helpers ---------- */
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  var cardMemo = {};
  function fetchCard(handle) {
    var key = 'rbsx:' + root + ':' + handle;
    if (cardMemo[key]) return cardMemo[key];
    var cached = ssGet(key);
    if (cached !== null) return (cardMemo[key] = Promise.resolve(cached));
    cardMemo[key] = fetch(root + 'products/' + encodeURIComponent(handle) + '?view=rb-search-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { html = String(html || '').trim(); ssSet(key, html); return html; })
      .catch(function () { return ''; });
    return cardMemo[key];
  }
  function parseCard(html) {
    var t = document.createElement('template');
    t.innerHTML = html;
    return t.content.querySelector('[data-rb-sx-card]');
  }
  function handleFromHref(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function recentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem('rb_recently_viewed') || '[]')
        .filter(function (r) { return r && r.h && Date.now() - (r.ts || 0) < 60 * 864e5; })
        .slice(0, 4);
    } catch (e) { return []; }
  }

  /* ---------- 2 · v2 layout before typing ---------- */
  function inputOf(modal) { return modal.querySelector('#d-gpt-query'); }
  function isEmpty(modal) { var i = inputOf(modal); return !i || !String(i.value || '').trim(); }

  function askFor(modal, text, index) {
    var originals = modal.querySelectorAll('.d-suggestion');
    if (originals[index]) { originals[index].click(); return; }
    var input = inputOf(modal);
    if (!input) return;
    var proto = input.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(input, text);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
    input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', code: 'Enter', keyCode: 13, bubbles: true }));
  }

  function fillAsk(modal, sx) {
    var texts = Array.prototype.map.call(modal.querySelectorAll('.d-suggestion-text, .d-suggestion'), function (el) {
      return (el.textContent || '').trim();
    }).filter(function (t, i, a) { return t && a.indexOf(t) === i; });
    var list = sx.querySelector('[data-rb-sx-ask-list]');
    var group = sx.querySelector('[data-rb-sx-ask]');
    if (!list || !texts.length) return;
    if (list.getAttribute('data-filled') === texts.join('|')) return;
    list.innerHTML = '';
    texts.forEach(function (text, i) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = text;
      b.addEventListener('click', function () { askFor(modal, text, i); });
      li.appendChild(b);
      list.appendChild(li);
    });
    list.setAttribute('data-filled', texts.join('|'));
    group.hidden = false;
  }

  function fillRecent(sx) {
    var grid = sx.querySelector('[data-rb-sx-recent-grid]');
    var box = sx.querySelector('[data-rb-sx-recent]');
    if (!grid || grid.getAttribute('data-filled')) return;
    grid.setAttribute('data-filled', '1');
    var items = recentlyViewed();
    if (!items.length) return;
    Promise.all(items.map(function (r) { return fetchCard(r.h); })).then(function (htmls) {
      htmls.forEach(function (html) { var c = html && parseCard(html); if (c) grid.appendChild(c); });
      if (grid.children.length) box.hidden = false;
    });
  }

  // The side columns are laid over the window (absolute), so the top-picks block is given their height:
  // the window then scrolls far enough to show the whole left column (Services) on short screens.
  // A ResizeObserver does the measuring, so nothing forces a layout while Depict is drawing.
  var sizeWatch = 'ResizeObserver' in window ? new ResizeObserver(function () {
    var sx = document.querySelector(MODAL + ' [data-rb-sx]');
    var picks = sx && sx.nextElementSibling;
    if (!picks) return;
    var h = 0;
    if (DESKTOP.matches) Array.prototype.forEach.call(sx.children, function (col) { h = Math.max(h, col.offsetHeight); });
    var want = h ? h + 'px' : '';
    if (picks.style.minHeight !== want) picks.style.minHeight = want;
  }) : null;
  function watchSize(sx) {
    if (!sizeWatch || sx.__rbWatched) return;
    sx.__rbWatched = true;
    Array.prototype.forEach.call(sx.children, function (col) { sizeWatch.observe(col); });
  }

  function layout(modal) {
    var picks = modal.querySelector('.d-top-picks');
    var on = !!picks && isEmpty(modal);
    if (modal.classList.contains('rb-sx-on') !== on) modal.classList.toggle('rb-sx-on', on);
    if (!on) return;
    var sx = picks.previousElementSibling;
    if (!sx || !sx.hasAttribute('data-rb-sx')) {
      var old = modal.querySelector('[data-rb-sx]');
      if (old) old.remove();
      var tpl = document.getElementById('rb-search-extras');
      if (!tpl) return;
      sx = tpl.content.firstElementChild.cloneNode(true);
      picks.parentNode.insertBefore(sx, picks);
    }
    if (!picks.classList.contains('rb-sx-mid')) picks.classList.add('rb-sx-mid');
    fillAsk(modal, sx);
    fillRecent(sx);
    watchSize(sx);
  }

  /* ---------- 3 · cloth under every product name, and a link on every card ---------- */
  // Depict's product feed has no handles today, so its cards come without a link (not clickable, and the theme
  // shows the "not allowed" cursor). An index of title → [handle, cloth] (templates/collection.rb-search-index.liquid)
  // is loaded once, early, and kept for 12 hours: each card then gets its link and its cloth line straight away.
  // A card Depict already links is left as it is; a title missing from the index falls back to predictive search.
  var INDEX_KEY = 'rbsx:index:' + root;
  var INDEX_TTL = 12 * 36e5;
  var index = null;
  var indexLoading = null;
  var indexFailed = false;
  function norm(t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function loadIndex() {
    if (index) return Promise.resolve(index);
    if (indexLoading) return indexLoading;
    try {
      var saved = JSON.parse(localStorage.getItem(INDEX_KEY) || 'null');
      if (saved && Date.now() - saved.t < INDEX_TTL && saved.p) { index = saved.p; return Promise.resolve(index); }
    } catch (e) {}
    var all = {};
    var english = {};
    function page(url, n, into) {
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.p) return;
          for (var k in d.p) into[k] = d.p[k];
          if (d.next && n < 8) return page(d.next + (d.next.indexOf('view=') > -1 ? '' : (d.next.indexOf('?') > -1 ? '&' : '?') + 'view=rb-search-index'), n + 1, into);
        });
    }
    // In Swedish and German the titles are translated, while Depict may still send English titles: the English
    // index is read too, matched by handle, and given the cloth in the visitor's language
    var loads = [page(root + 'collections/all?view=rb-search-index', 0, all)];
    if (root !== '/') loads.push(page('/collections/all?view=rb-search-index', 0, english));
    indexLoading = Promise.all(loads)
      .then(function () {
        var clothByHandle = {};
        for (var k in all) clothByHandle[all[k][0]] = all[k][1];
        for (var e in english) if (!all[e]) all[e] = [english[e][0], clothByHandle[english[e][0]] || english[e][1]];
        if (!Object.keys(all).length) { indexFailed = true; return null; }
        index = all;
        try { localStorage.setItem(INDEX_KEY, JSON.stringify({ t: Date.now(), p: all })); } catch (e) {}
        queue();
        return index;
      })
      .catch(function () { indexFailed = true; return null; })
      .then(function (r) { indexLoading = null; if (!r) queue(); return r; });
    return indexLoading;
  }
  // Load it before the window opens: when the browser is idle after the page, and when the magnifier is pointed at
  function preload() {
    if (!index && !indexLoading) loadIndex();
    // the Recently viewed cards and their photos, ready before the window opens
    recentlyViewed().forEach(function (r) {
      fetchCard(r.h).then(function (html) {
        var img = html && parseCard(html) && parseCard(html).querySelector('img');
        if (img) { var pre = new Image(); pre.srcset = img.getAttribute('srcset') || ''; pre.sizes = img.getAttribute('sizes') || ''; pre.src = img.getAttribute('src'); }
      });
    });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(preload, { timeout: 4000 });
  else setTimeout(preload, 2500);
  document.addEventListener('pointerover', function (e) { if (e.target.closest && e.target.closest('[data-rb-search-open], .opens-depict')) preload(); }, { passive: true });
  document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest('[data-rb-search-open], .opens-depict')) preload(); });

  var titleMemo = {};
  function handleForTitle(title) {
    if (titleMemo[title]) return titleMemo[title];
    var key = 'rbsx:t:' + root + ':' + title;
    var cached = ssGet(key);
    if (cached !== null) return (titleMemo[title] = Promise.resolve(cached || null));
    titleMemo[title] = fetch(root + 'search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=3', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        var hit = list.filter(function (p) { return norm(p.title) === norm(title); })[0] || list[0];
        var h = hit ? hit.handle : '';
        ssSet(key, h);
        return h || null;
      })
      .catch(function () { return null; });
    return titleMemo[title];
  }
  function putCloth(title, cloth) {
    return; // cloth line off (5 Oct): the name already says the cloth
    var next = title.nextElementSibling;
    if (!cloth || (next && next.classList.contains('rb-sx-cloth'))) return;
    var span = document.createElement('span');
    span.className = 'rb-sx-cloth';
    span.textContent = cloth;
    title.insertAdjacentElement('afterend', span);
  }
  function putLink(card, handle) {
    if (!card || !handle || card.getAttribute('href')) return;
    card.setAttribute('href', root + 'products/' + encodeURIComponent(handle));
  }
  function decorate(modal) {
    var titles = modal.querySelectorAll('.depict-title:not([data-rb-cloth="done"])');
    Array.prototype.forEach.call(titles, function (title) {
      if (title.closest('[data-rb-sx]')) return;
      var card = title.closest('.depict-product-card, gpt-search-product-card, a');
      var text = norm(title.textContent);
      var hit = index && index[text];
      if (hit) {
        putLink(card, hit[0]);
        putCloth(title, hit[1]);
        title.setAttribute('data-rb-cloth', 'done');
        return;
      }
      if (!index) {
        if (!indexLoading && !indexFailed) loadIndex();
        if (indexLoading) return; // the index is on its way; it re-runs this when it lands
      }
      if (title.getAttribute('data-rb-cloth') === 'slow') return;
      title.setAttribute('data-rb-cloth', 'slow');
      var href = card && card.getAttribute('href');
      var handle = href ? handleFromHref(href) : null;
      (handle ? Promise.resolve(handle) : handleForTitle(text))
        .then(function (h) {
          if (!h) return '';
          putLink(card, h);
          return fetchCard(h);
        })
        .then(function (html) {
          var c = html && parseCard(html);
          putCloth(title, c && c.getAttribute('data-cloth'));
          title.setAttribute('data-rb-cloth', 'done');
        });
    });
  }

  /* ---------- 4 · prices in the site's format ---------- */
  // The extras template carries rb-money's output for 1,234 (data-rb-money, e.g. "1,234 SEK" or "€1.234"):
  // its prefix, thousands separator and suffix are applied to Depict's amount. Real cents and a currency that
  // doesn't match the visitor's market keep Depict's own text.
  var SYMBOLS = { '€': 'EUR', '$': 'USD', '£': 'GBP' };
  function currencyOf(s) {
    s = String(s || '').replace(/\s+/g, '');
    var code = s.match(/[A-Z]{3}/);
    if (code) return code[0];
    for (var k in SYMBOLS) if (s.indexOf(k) > -1) return SYMBOLS[k];
    return s;
  }
  function groupDigits(digits, sep) { return digits.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  var moneyPattern;
  function pattern() {
    if (moneyPattern !== undefined) return moneyPattern;
    var tpl = document.getElementById('rb-search-extras');
    var sample = tpl && (tpl.getAttribute('data-rb-money') || '').replace(/\u00a0/g, ' ');
    var m = sample && sample.match(/^(.*?)1([^\d]?)234(.*)$/);
    moneyPattern = m ? { pre: m[1], sep: m[2], post: m[3], cur: currencyOf(m[1] + m[3]) } : null;
    return moneyPattern;
  }
  function sitePrice(text) {
    var t = String(text || '').replace(/[\u00a0\u202f\u2009]/g, ' ').trim();
    var m = t.match(/^([^\d]*?)\s*(\d[\d.,' ]*\d|\d)\s*([^\d]*)$/);
    if (!m) return null;
    var cur = currencyOf(m[1] + m[3]);
    var num = m[2];
    var cents = num.match(/[.,](\d{1,2})$/);
    if (cents && +cents[1] !== 0) return null;
    var digits = (cents ? num.slice(0, -cents[0].length) : num).replace(/\D/g, '');
    var p = pattern();
    // Swedish/Danish/Norwegian Depict writes just "kr": that is the visitor's krona
    if (p && /^kr\.?$/i.test(cur) && /^(SEK|NOK|DKK)$/.test(p.cur)) cur = p.cur;
    if (p) return p.cur === cur ? p.pre + groupDigits(digits, p.sep) + p.post : null;
    return /^(SEK|NOK|DKK)$/.test(cur) ? groupDigits(digits, ',') + ' ' + cur : null; // template without the sample
  }
  function formatPrices(modal) {
    Array.prototype.forEach.call(modal.querySelectorAll('.depict-price, .d-original-price'), function (el) {
      var src = el.textContent;
      if (el.getAttribute('data-rb-src') === src) return;
      el.setAttribute('data-rb-src', src);
      var out = sitePrice(src);
      if (out && out !== src.replace(/[\u00a0\u202f\u2009]/g, ' ').trim()) el.setAttribute('data-rb-price', out);
      else el.removeAttribute('data-rb-price');
    });
  }

  /* ---------- keep it applied while Depict re-renders ---------- */
  var queued = false;
  function apply() {
    queued = false;
    var modal = document.querySelector(MODAL);
    if (!modal) return;
    try { layout(modal); } catch (e) {}
    try { decorate(modal); } catch (e) {}
    try { formatPrices(modal); } catch (e) {}
  }
  // Run before the browser paints (a microtask after Depict's DOM change), so the window never shows a frame
  // without the extras, cloth or prices
  function queue() { if (!queued) { queued = true; Promise.resolve().then(apply); } }
  // Only Depict's window matters: changes elsewhere on the page, and our own additions inside it, are ignored
  function relevant(records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!el) continue;
      if (el.closest('[data-rb-sx]')) continue;
      if (el.closest(MODAL)) return true;
      var added = records[i].addedNodes;
      for (var j = 0; added && j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches(MODAL) || n.querySelector(MODAL))) return true;
      }
    }
    return false;
  }
  new MutationObserver(function (records) { if (relevant(records)) queue(); })
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['open', 'class'] });
  document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest(MODAL)) queue(); }, true);
  window.addEventListener('resize', queue);
})();
